module.exports = __webpack_public_path__ + "img/btn.0da6faac.png";